import { useState } from "react";
import { Row, Col, Card, Spinner } from "react-bootstrap";

function ArtworkImage({ artwork }) {
  const [failed, setFailed] = useState(false);
  const { imageUrl, alt, placeholder } = artwork;

  if (imageUrl && !failed) {
    return (
      <Card.Img
        variant="top"
        src={imageUrl}
        alt={alt}
        onError={() => setFailed(true)}
      />
    );
  }

  // Fall back to the low-quality placeholder embedded in the API response,
  // which still works when the image server is unavailable
  if (placeholder?.lqip) {
    const aspectRatio =
      placeholder.width && placeholder.height
        ? `${placeholder.width} / ${placeholder.height}`
        : undefined;
    return (
      <div className="lqip-frame card-img-top" style={{ aspectRatio }}>
        <img className="lqip" src={placeholder.lqip} alt={alt} />
      </div>
    );
  }

  return null;
}

function SearchResults({ results, loading }) {
  if (loading) {
    return (
      <Row>
        <Spinner className="mx-auto" animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </Row>
    );
  }

  if (!(results && results.length)) {
    return null;
  }

  return (
    <Row>
      {results.map((artwork) => (
        <Col xs={12} md={4} lg={3} key={artwork.id}>
          <Card>
            <ArtworkImage artwork={artwork} />
            <Card.Body>
              <Card.Title>{artwork.title}</Card.Title>
              {artwork.artist ? (
                <Card.Subtitle className="text-muted">{artwork.artist}</Card.Subtitle>
              ) : null}
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default SearchResults;
